module.exports = __webpack_public_path__ + "static/media/sample_share_of_business.ef25c0d8.csv";